export enum LocalStorageEnum {
    USER = 'user',
    JWT = 'jwt',
    CAN_DEL_DRIVER = 'canDeleteDriver',
    OVERRIDE_URL = 'overrideURL'
}
